<!--
 * @Description:
 * @Author: JiuYue
 * @Date: 2020-10-10 17:18:44
 * @Reference:
-->
<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view></router-view>
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  name: 'app',
  data () {
    return {
      locale: zhCN
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
